import { FormApi } from "final-form";
import * as React from "react";

function maybeSpace(char: string): "" | " " {
  if (char === "" || char === " ") {
    return "";
  }
  return " ";
}

export const insertTextAtCursor = (
  ref: React.RefObject<HTMLTextAreaElement | HTMLInputElement>,
  form: FormApi,
  fieldName: string,
  textToInsert: string
): void => {
  const textarea = ref.current;
  // @ts-expect-error TS(2531): Object is possibly 'null'.
  const textBeforeCursor = textarea.value.substring(0, textarea.selectionStart);
  // @ts-expect-error TS(2531): Object is possibly 'null'.
  const textAfterCursor = textarea.value.substring(textarea.selectionEnd, textarea.value.length);
  const maybeSpaceBefore = maybeSpace(textBeforeCursor.charAt(textBeforeCursor.length - 1));
  const maybeSpaceAfter = maybeSpace(textAfterCursor.charAt(0));
  // @ts-expect-error TS2339
  const { touched } = form.getFieldState(fieldName);
  const newValue = touched
    ? textBeforeCursor + maybeSpaceBefore + textToInsert + maybeSpaceAfter + textAfterCursor
    : // @ts-expect-error TS(2531): Object is possibly 'null'.
      textarea.value + (textarea.value.substring(-1) === " " ? "" : " ") + textToInsert; // we want it at the end if not touched
  form.change(fieldName, newValue);
};

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type, @typescript-eslint/no-explicit-any
export function shouldDisplayError(meta: any) {
  return meta.submitFailed || (meta.touched && !meta.pristine && meta.error);
}
